// extracted by mini-css-extract-plugin
module.exports = {"level":"Footer_level__IiMeX","levelRight":"Footer_levelRight__3-u9r"};